var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScannerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350.39,
    height: 350.39,
    viewBox: "0 0 350.39 350.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57593",
    "data-name": "Group 57593",
    transform: "translate(-905.305 -183.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155580",
    "data-name": "Path 155580",
    d: "M346.455,2.907a10.185,10.185,0,0,1,10.174,10.174V32.454h2.907V13.081A13.1,13.1,0,0,0,346.455,0H327.02V2.907Z",
    transform: "translate(895.659 184.305)",
    fill: "#5a31ee",
    stroke: "#5a31ee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155581",
    "data-name": "Path 155581",
    d: "M2.907,13.081A10.185,10.185,0,0,1,13.081,2.907H32.468V0H13.081A13.1,13.1,0,0,0,0,13.081V32.454H2.907Z",
    transform: "translate(905.805 184.305)",
    fill: "#5a31ee",
    stroke: "#5a31ee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155582",
    "data-name": "Path 155582",
    d: "M356.629,346.454a10.185,10.185,0,0,1-10.174,10.174H327.02v2.907h19.435a13.1,13.1,0,0,0,13.081-13.081V327.005h-2.907Z",
    transform: "translate(895.659 174.159)",
    fill: "#8f69ec",
    stroke: "#8f69ec",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155583",
    "data-name": "Path 155583",
    d: "M13.081,356.628A10.185,10.185,0,0,1,2.907,346.454V327.005H0v19.449a13.1,13.1,0,0,0,13.081,13.081H32.468v-2.907Z",
    transform: "translate(905.805 174.159)",
    fill: "#8f69ec",
    stroke: "#8f69ec",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannerOutline);
export default __webpack_public_path__ + "static/media/scanner-outline.5deb395f8ec1cb551feaa56c654ad5eb.svg";
export { ForwardRef as ReactComponent };